
requireAll( require.context( './partials/', true, /\.js$/ ) );

function requireAll( r ) {
	r.keys().forEach( r );
}


// // Get all JavaScript files in the ./partials/ directory
// const context = require.context('./partials/', true, /\.js$/);

// // Define the order you want the files to be required
// const filesOrder = [
//   './partials/site-scripts.js',
//   './partials/scroll-animations.js',
//   // Add other file paths in the desired sequence
// ];

// // Filter the keys based on the defined order
// const sortedKeys = filesOrder.filter(file => context.keys().includes(file));

// // Require the files in the sorted order
// requireAll(sortedKeys.map(key => context(key)));

// function requireAll(files) {
//   files.forEach(file => {
//     // Require each file
//     require(file);
//   });
// }
